import { render, staticRenderFns } from "./addYg.vue?vue&type=template&id=64fa3154&"
import script from "./addYg.vue?vue&type=script&lang=js&"
export * from "./addYg.vue?vue&type=script&lang=js&"
import style0 from "./addYg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports